import React from 'react';
import propTypes from 'prop-types';
import cx from 'classnames';

import { useTranslate } from '../Internationalization';
import { Bar, BarItem } from '../../components';
import { useCurrentPage } from '../Page';
import LanguageSelector from '../LanguageSelector';
import Link from '../Link';

import messages from './messages';

const CLASS_ROOT = 'main-nav';

const Menu = ({ id, className, isMobile }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--mobile`]: isMobile,
    },
    className
  );

  const pages = [
    'index',
    'projects',
    'services',
    'studio',
    'insights',
    'contact',
  ];

  return (
    <nav id={id} className={classes}>
      <Bar
        tag="ul"
        nowrap
        direction={isMobile ? 'vertical' : 'horizontal'}
        className="list--unstyled mb-none mt-none"
      >
        {pages.map(page => (
          <MenuLink key={page} to={page} isMobile={isMobile} />
        ))}
      </Bar>
      {isMobile && <LanguageSelector />}
    </nav>
  );
};

Menu.propTypes = {
  id: propTypes.string,
  className: propTypes.string,
  isMobile: propTypes.bool,
};

const MenuLink = ({ to: pageName, isMobile }) => {
  const currentPage = useCurrentPage();
  const t = useTranslate(messages);

  return (
    <BarItem tag="li" className="mt-none mb-none">
      <Link
        to={pageName}
        isActive={currentPage === pageName}
        className="mb-none"
        {...(isMobile
          ? {
              size: 'small',
              className: 'mb-small',
            }
          : {})}
      >
        {t(pageName)}
      </Link>
    </BarItem>
  );
};

MenuLink.propTypes = {
  to: propTypes.string.isRequired,
  isMobile: propTypes.bool,
};

export default Menu;



// WEBPACK FOOTER //
// ./src/modules/Menu/index.js